export default __webpack_public_path__ + "static/media/vitasis-logo-white.f448e8a7.png";